<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">
        <v-icon>upload</v-icon>
        {{ title || "Upload Excel" }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ title || "Upload Excel" }}</span>
        <v-spacer></v-spacer>
        <v-icon color="red darken-1" flat large @click="dialog = false">
          close
        </v-icon>
      </v-card-title>
      <v-container class="pa-3">
        <v-form>
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="error pa-2 text-white" v-if="errorMsg">
                {{ errorMsg }}
              </h3>
              <h3 class="success pa-2 text-white" v-if="successMsg">
                {{ successMsg }}
              </h3>
            </v-flex>
            <v-flex xs12>
              <v-select
                prepend-icon="manage_accounts"
                :items="items"
                label="User Type"
                @change="handleChange"
              />

              <v-text-field
                label="Select Excel"
                @click="onPickFile"
                v-model="fileName"
                prepend-icon="attach_file"
              ></v-text-field>
              <!-- Hidden -->
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @change="onFilePicked"
              />

              <v-btn
                color="primary"
                @click="onUploadSelectedFileClick"
                :loading="loading"
                :disabled="loading || !fileObject || !apiUrl"
              >
                Upload
              </v-btn>
              <div v-if="validationErrors.length">
                <div v-for="(error, index) in validationErrors" :key="index">
                  <br />
                  Row:
                  <b>{{ error.row }}</b>
                  . Error:
                  <span style="color: red">{{ error.errors[0] }}</span>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import {
    uploadUsersExcelUrl,
    uploadChaldalUsersExcelUrl,
  } from "@/utils/variables";

  export default {
    props: ["title"],
    data: () => ({
      loading: false,
      dialog: false,
      validationErrors: [],
      errorMsg: "",
      successMsg: "",
      fileName: "",
      url: "",
      fileObject: null,
      cardResult: "",
      name: "",
      size: "",
      type: "",
      lastModifiedDate: "",
      apiUrl: "",
      items: [
        { text: "Chaldal Users", value: 1 },
        { text: "Others", value: 2 },
      ],
    }),
    watch: {
      dialog() {
        this.validationErrors = [];
        this.errorMsg = "";
        this.successMsg = "";
        this.fileName = "";
        this.fileObject = null;
        this.url = "";
        this.$refs.fileInput.value = "";
      },
    },
    methods: {
      handleChange(e) {
        if (e === 1) {
          this.apiUrl = uploadChaldalUsersExcelUrl;
        } else {
          this.apiUrl = uploadUsersExcelUrl;
        }
      },
      onPickFile() {
        this.$refs.fileInput.click();
      },
      onFilePicked(event) {
        const files = event.target.files;
        if (files[0] !== undefined) {
          this.fileName = files[0].name;
          // Check validity of file
          if (this.fileName.lastIndexOf(".") <= 0) {
            return;
          }
          // If valid, continue
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", () => {
            this.url = fr.result;
            this.fileObject = files[0]; // this is an file that can be sent to server...
          });
        } else {
          this.fileName = "";
          this.fileObject = null;
          this.url = "";
        }
      },
      async onUploadSelectedFileClick() {
        this.loading = true;
        this.successMsg = this.errorMsg = "";
        this.validationErrors = [];

        let formData = new FormData();
        formData.append("file", this.fileObject);

        // console.log(this.fileObject);
        // A file is not chosen!
        if (!this.fileObject) {
          alert("No file!!");
        }
        // DO YOUR JOB HERE with fileObjectToUpload
        // https://developer.mozilla.org/en-US/docs/Web/API/File/File
        // this.name = this.fileObject.name;
        // this.size = this.fileObject.size;
        // this.type = this.fileObject.type;
        // this.lastModifiedDate = this.fileObject.lastModifiedDate;
        // DO YOUR JOB HERE with fileObjectToUpload
        else {
          try {
            const { data } = await HTTP().post(this.apiUrl, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            if (data.error) {
              this.errorMsg = data.errorMsg;
              if (data.statusCode == 400) {
                if (data.data && data.data.length) {
                  this.validationErrors = data.data.sort(
                    (a, b) => a.row - b.row
                  ); // Sorting based on row number
                }
              }
            } else {
              this.successMsg = data.errorMsg;
              this.$emit("success");
            }
            // console.log(data);
          } catch (error) {
            this.errorMsg = "Something wrong happened. Please try again";
            // console.log(error);
          }
        }
        this.loading = false;
      },
    },
  };
</script>
<style scoped>
  .text-white {
    color: #fff !important;
  }
</style>
